export function showToast(msg: string, sub: string, color: string): void {
  const t = document.getElementById('toast');
  if (!t) return;
  t.innerHTML = msg + (sub ? `<small>${sub}</small>` : '');
  t.style.borderColor = color;
  t.style.color = color;
  t.style.display = 'block';
}

export function hideToast(): void {
  const t = document.getElementById('toast');
  if (t) t.style.display = 'none';
}

export function setupToastClick(onReset: () => void): void {
  const t = document.getElementById('toast');
  if (!t) return;
  t.addEventListener('click', onReset);
  t.addEventListener(
    'touchstart',
    (e) => {
      onReset();
      e.preventDefault();
    },
    { passive: false },
  );
}
